/* eslint-disable react/destructuring-assignment */
import React, { ReactNode, useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Typography, TypographyProps } from '@mui/material';

export type CopyableFieldProps = TypographyProps & {
  value: string | number | any;
  label?: string | ReactNode;
};

export default function CopyableField(props: CopyableFieldProps) {
  const [copied, setCopied] = useState(false);
  const { value, label, className, children, ...rest } = props;

  return (
    <Typography component="span" className={className} {...rest}>
      {label ?? value}
      {children}
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          navigator.clipboard.writeText(value).then(() => {
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 2000);
          });
        }}
        size="small"
        title={'Copy ' + (label ?? value)}
        aria-label={'Copy ' + (label ?? value)}
      >
        {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
      </IconButton>
    </Typography>
  );
}
